export default __webpack_public_path__ + "static/media/placeBets.a4aaa326.mp3";